import React from "react";
import { CrewPilotModuleShell } from "../../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../../layout/pageLayout";
import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import {
  DEFAULT_ESTIMATE_REPORT_OPTIONS,
  ESTIMATE_REPORT_OPTION_DEFS,
} from "../../../helpers/estimateReport";

const CARD_STYLE = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(201,168,76,0.25)",
  borderRadius: "14px",
  padding: "20px",
  marginBottom: "16px",
};

const CHECK_ROW_STYLE = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "12px 0",
  borderBottom: "1px solid rgba(201,168,76,0.12)",
  fontSize: "15px",
};

export function EstimateReportOptionsScreen({
  estimateTitle,
  estimateNumber,
  options,
  onChange,
  onPreview,
  onBack,
}) {
  const isDesktop = useIsDesktopViewport();
  const mergedOptions = { ...DEFAULT_ESTIMATE_REPORT_OPTIONS, ...options };

  function toggleOption(key) {
    const def = ESTIMATE_REPORT_OPTION_DEFS.find((entry) => entry.key === key);
    if (def?.future) return;

    onChange?.({
      ...mergedOptions,
      [key]: !mergedOptions[key],
    });
  }

  return (
    <CrewPilotModuleShell
      title="Report Options"
      subtitle={estimateNumber || estimateTitle || "Estimate Report"}
      sectionLabel="Estimate Report"
      onBack={onBack}
      desktopBackLabel="Estimate Summary"
      layout={isDesktop ? PAGE_LAYOUT.FORM : undefined}
    >
      <div style={CARD_STYLE}>
        <div
          style={{
            fontWeight: 600,
            fontSize: "16px",
            marginBottom: "4px",
            color: "#c9a84c",
          }}
        >
          Report Options
        </div>
        <div style={{ opacity: 0.72, fontSize: "14px", marginBottom: "8px" }}>
          Choose what to include in the client-facing report preview.
        </div>

        {ESTIMATE_REPORT_OPTION_DEFS.map((def) => {
          const checked = Boolean(mergedOptions[def.key]);
          const disabled = def.future;

          return (
            <label
              key={def.key}
              style={{
                ...CHECK_ROW_STYLE,
                opacity: disabled ? 0.45 : 1,
                cursor: disabled ? "not-allowed" : "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={() => toggleOption(def.key)}
                style={{ width: "18px", height: "18px", accentColor: "#c9a84c" }}
              />
              <span>
                {def.label}
                {def.future ? " (future)" : ""}
              </span>
            </label>
          );
        })}
      </div>

      <button
        type="button"
        className="nx-btn nx-btn-gold"
        style={isDesktop ? { minWidth: "220px" } : { width: "100%" }}
        onClick={() => onPreview?.(mergedOptions)}
      >
        Preview Report
      </button>
    </CrewPilotModuleShell>
  );
}
